// extracted by mini-css-extract-plugin
module.exports = {"container":"Xl-z","disabled":"Yl-z","bgBlack":"Zl-z","content":"_l-z","countdown":"am-z","topCaption":"bm-z","topHeading":"cm-z","heading":"dm-z","copy":"em-z"};